const model = {
  cadd: {
    retrived: false,
    data: {
      projects: 0,
      sites: 0,
      suppliers: 0,
      kycProgress: 0,
      timeline: [],
      map: [],
    },
  },
  pme: {
    retrived: false,
    data: {},
  },
}

export default model;
